import { useMemo } from 'react'
import { useStepImpacts } from '../steps'

interface IProps {
  selectedImpact: string | null
  setSelectedImpact: (id: string | null) => void
  stepId: string
}

export const useStepImpactsSelection = ({ selectedImpact, setSelectedImpact, stepId }: IProps) => {
  const { data: impacts } = useStepImpacts(stepId)

  const selectedImpacts = useMemo(() => {
    if (!impacts?.data?.length || !selectedImpact) return []
    const item = impacts.data.find((item) => item.id === selectedImpact)

    if (!item) return []

    return [item]
  }, [selectedImpact, impacts])

  const handleSelectedImpact = (id: string) => {
    id !== selectedImpact ? setSelectedImpact(id) : setSelectedImpact(null)
  }

  return { selectedImpacts, handleSelectedImpact }
}
